module.exports = __webpack_public_path__ + "img/caba_fall.7ea11f62.svg";